import React from 'react';
import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUnreadTask } from '../../hooks/useUnread';

/**
 * Unread indicator for a task row.
 *
 * A plain comment gets an icon with no number: it says "there is something
 * here", nothing more. Only an @mention gets a count, so a number anywhere in
 * the UI always means "someone wants something from you". Same split Slack
 * draws between a bold channel and a blue mention badge.
 */
const UnreadBadge = ({ taskId, className = '' }) => {
  const { t } = useTranslation();
  const { comments, mentions } = useUnreadTask(taskId);

  if (mentions > 0) {
    return (
      <span
        title={t('unread.mention', { count: mentions })}
        className={`inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-blue-500 text-white text-[10px] font-semibold leading-none ${className}`}
      >
        {mentions}
      </span>
    );
  }

  if (comments > 0) {
    return (
      <span
        title={t('unread.comment', { count: comments })}
        className={`inline-flex items-center text-blue-400 ${className}`}
      >
        <MessageSquare className="w-3 h-3 fill-current" />
      </span>
    );
  }

  return null;
};

export default UnreadBadge;
